module.exports = __webpack_public_path__ + "static/img/back.9894677.png";


//////////////////
// WEBPACK FOOTER
// ./src.common/assets/role/back.png
// module id = 69
// module chunks = 0